<template>
  <div class="base-input">
    <ValidationProvider v-if="field.type === 'select'" v-slot="{ errors }" :rules="rules">
      <b-field
        :label="field.label"
        :horizontal="field.isHorizontal"
        :type="errors[0] ? 'is-danger' : ''"
        :message="errors[0]">
        <b-select
          :id="id"
          v-model="localValue"
          :data-cy="`base-input-select-${id}`"
          :placeholder="field.placeholder"
          :size="field.size ? field.size : 'is-small'"
          expanded>
          <option
            v-for="option in field.options"
            :key="option.value"
            :value="option.value">
            {{ option.label }}
          </option>
        </b-select>
      </b-field>
    </ValidationProvider>
    <ValidationProvider v-else-if="field.type === 'switch'" v-slot="{ errors }" :rules="rules">
      <b-field :label="field.label" :horizontal="field.isHorizontal">
        <b-switch
          :id="id"
          v-model="localValue"
          :data-cy="`base-input-switch-${id}`"
          :size="field.size ? field.size : 'is-small'">
          {{ !field.isHorizontal ? field.placeholder : '' }}
        </b-switch>
      </b-field>
      <p class="help is-danger">{{ errors[0] }}</p>
    </ValidationProvider>
    <ValidationProvider v-else-if="field.type === 'number'" v-slot="{ errors }" :rules="rules">
      <div
        class="field has-addons"
        :class="{ 'is-horizontal': field.isHorizontal, 'is-small': !field.size, [field.size]: field.size }">
        <div v-if="field.title" class="field-title">
          <small>{{ field.title }}</small>
        </div>
        <div v-if="field.label" class="field-label">
          <label class="label">{{ field.label }}</label>
        </div>
        <div class="field-body">
          <div v-if="(field.prefixPosition === 'left' && field.prefix)" class="control">
            <p class="pos-left">
              <span class="button is-static">{{ field.prefix !== '' ? field.prefix : '' }}</span>
            </p>
          </div>
          <div class="control">
            <b-input
              :id="id"
              v-model="localValue"
              :size="field.size ? field.size : 'is-small'"
              :data-cy="`base-input-number-${id}`"
              type="number"
              min="0"
              :icon="field.icon"
              :placeholder="field.placeholder"
              expanded />
            <p class="help is-danger">{{ errors[0] }}</p>
          </div>
          <div v-if="field.prefixPosition === 'right' && field.prefix" class="control">
            <p class="pos-right">
              <span class="button is-static">{{ field.prefix }}</span>
            </p>
          </div>
        </div>
      </div>
    </ValidationProvider>
    <ValidationProvider v-else v-slot="{ errors }" :rules="rules">
      <b-field
        :label="field.label"
        :horizontal="field.isHorizontal"
        :type="errors[0] ? 'is-danger' : ''"
        :message="errors[0]">
        <b-input
          :id="id"
          v-model="localValue"
          :data-cy="`base-input-text-${id}`"
          :placeholder="field.placeholder"
          :size="field.size ? field.size : 'is-small'"
          type="text"
          :icon="field.icon"
          expanded />
      </b-field>
    </ValidationProvider>
  </div>
</template>

<script>

export default {
  name: 'BaseInput',
  props: {
    id: String,
    field: {
      type: Object,
      required: true,
      default: () => ({
        prefix: '$',
        prefixPosition: 'left'
      })
    },
    rules: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number, Boolean],
      default: null
    }
  },
  data() {
    return {
      localValue: null
    };
  },
  watch: {
    value(newValue) {
      this.localValue = this.updateInput(newValue);
    },
    localValue(newPropValue) {
      this.$emit('input', newPropValue);
    }
  },
  created() {
    this.localValue = this.updateInput(this.value);
  },
  methods: {
    updateInput(value) {
      if (value === null || value === undefined) return null;
      if (this.field.type === 'input') return String(value);
      if (this.field.type === 'number') return +value;
      if (this.field.type === 'switch') return Boolean(value);
      if (this.field.type === 'select' && typeof value === 'number') return value;
      return String(value);
    }
  }
};
</script>

<style>
.base-input .field input[type=text],
.base-input .field input[type=number],
.base-input .field textarea,
.base-input .field select {
  background-color: #FFFFFF !important;
  border-color: #dcdcdc;
}
.base-input .field.is-horizontal.is-small .field-label {
  padding-top: 0.375em;
}
.base-input .has-addons.is-small .field-label label {
  margin-right: 5px !important;
}
.base-input .field .has-addons a {
  height: 30px;
  background-color: #EEF2F6;
  border-color: #dbdbdb;
}
.base-input .field-label label {
  font-size: 0.875rem !important;
  font-weight: 400;
}

.base-input .field.is-small .control span {
  font-size: 0.75rem;
}
.base-input .field.has-addons .control.is-expanded {
  flex-grow: 1;
}
#evaluation-panel .field.is-small .control span {
  background-color: #EEF2F6;
  border-color: #ECEFF4;
  color: hsl(0, 0%, 48%);
}
@media screen and (max-width: 769px) {
  .base-input .field.is-horizontal.is-small{
    display: block;
  }
}
@media screen and (max-width: 768px) {
  .base-input .is-horizontal .field-label {
    flex-grow: 1;
  }
  .base-input .is-horizontal .field-body{
    display: flex;
    width: 100%;
    align-content: stretch;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .field-body > .control:first-child {
    flex: 4;
  }
  .field-body > .control:last-child:not(:only-child) {
    flex: 0;
  }
  .base-input .field{
    width: 100%;
  }
}
</style>
